import React from 'react';
import './NextEvents.style.css';

const NextEvents = () => {
  return (
    <div >
      <h1>Suramericano Beach Tennis IFBT y OpenMedellin 2024</h1>
    </div>
  );
};

export default NextEvents;
